import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    Approves,
    BigToString
} from '../../ethers/e'

import {
    Multi,
    SilverPool,
    Usdt
} from '../../chain/silver'

import {useEthers} from '../../ethers'
import useButtonText from '../useButtonText'
import useToast from '../useToast'
import { useTranslation } from 'react-i18next'

function Error(e) {
    return e.data ? e.data.data ? e.data.data.message : (e.data.message ? e.data.message : e.message) : e.message
}

async function initP(account) {
    const silverContract = SilverPool()
    // return silverContract.userProtocal(account)
    return "0x0000000000000000000000000000000000000000000000000000000000000000" === await silverContract.userProtocal(account)
}

export function useProtocal() {
    const {account, getBlockNumber} = useEthers()
    const [needSign, setSign] = useState(false)
    useEffect(() => {
        const init = async () => {
            setSign(
                await initP(account)
            )
        }
        init()
    }, [account, getBlockNumber()])

    return needSign
}


export function useSign(hash) {
    const {open} = useToast()
    const {t} = useTranslation()
    const history = useHistory()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Agree'))

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.protocal(hash)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()

            open(t("Success"))
            history.goBack()
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}
